// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ParagraphSvg from '@rsuite/icon-font/lib/file/Paragraph';
var Paragraph = createSvgIcon({
  as: ParagraphSvg,
  ariaLabel: 'paragraph',
  category: 'file',
  displayName: 'Paragraph'
});
export default Paragraph;